/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_KYC_DOCS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateKycMethods extends IPluginMethodMap {
  getUpdateKyc(args: any): Promise<any>;
}

export interface UpdateKycProps {
  addressProofType?: string;
  idProofType?: string;
  addressProof?: any;
  idProof?:any;
  docIds?: string[];
}

export class UpdateKycService implements IAgentPlugin {
  readonly methods: IUpdateKycMethods;

  constructor() {
    this.methods = {
      getUpdateKyc: this.getUpdateKyc.bind(this),
    };
  }

  async getUpdateKyc(args: UpdateKycProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_KYC_DOCS,
          variables: {
            input: {
              updates: this.getDocuments(args), 
              docIds: args?.docIds || [],
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.editKYCDoc) {
          return {
            data: res?.data?.editKYCDoc?.message,
          };
        }
        return {
          data: res?.data
        }
      }
    } catch (err: any) {
      console.log("errrror in update Kyc by Id", err);
      throw err;
    }
  }

  private getDocuments(args: UpdateKycProps) {
    let _updates = [];
    console.log("id proof in payload :", args?.idProof)
    console.log("address proof in payload :",args?.addressProof)
    if (args?.idProofType) {
      _updates.push({
        doc: args?.idProof[0]?.base64 || null,
        type: "ID_PROOF",
        name: args?.idProofType || null,
        fileType: args?.idProof[0]?.type || [],
        status: "SUBMITTED",
      });
    }
    if (args?.addressProofType) {
      _updates.push({
        doc: args?.addressProof[0]?.base64 || null,
        type: "ADDRESS_PROOF",
        name: args?.addressProofType || null,
        fileType: args?.addressProof[0]?.type || [],
        status: "SUBMITTED",
      });
    }
    return _updates;
  }
  
}
